import { InstallerStatusEnum } from '@bo-client/shared/models/installerPassDto';
import { StatusDefinition } from '../status.model';

/** Installateurausweis (`InstallerPass.status`). `Initialized` hat bewusst keine Definition (nie gesetzt). */
export const INSTALLER_PASS_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  { value: InstallerStatusEnum.PendingDocuments, defaultLabel: 'Unvollständig', defaultColor: '#ffcb6b' },
  {
    value: InstallerStatusEnum.DocumentsComplete,
    defaultLabel: 'Dokumente vollständig',
    defaultColor: '#80cbc4'
  },
  { value: InstallerStatusEnum.ReadyToValidate, defaultLabel: 'Bereit zur Prüfung', defaultColor: '#80cbc4' },
  {
    value: InstallerStatusEnum.RequestValidation,
    defaultLabel: 'Prüfung beantragt',
    defaultColor: '#C792EA'
  },
  { value: InstallerStatusEnum.Invalid, defaultLabel: 'Ungültig', defaultColor: '#d5756c' },
  { value: InstallerStatusEnum.Valid, defaultLabel: 'Gültig', defaultColor: '#C3E88D' },
  { value: InstallerStatusEnum.Expired, defaultLabel: 'Abgelaufen', defaultColor: '#d5756c' },
  {
    value: InstallerStatusEnum.RequestRenew,
    defaultLabel: 'Verlängerung beantragt',
    defaultColor: '#d5756c'
  },
  { value: InstallerStatusEnum.FeedbackNeeded, defaultLabel: 'Rückfrage', defaultColor: '#f0b429' }
];
